import React, { createContext, useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { useImmer } from "use-immer";

import { claims, claimValues, userRoles } from '../utilities/authConstants';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { AuthenticationService } from '../services';
import { applicationContextActionCreator, modalActionCreator } from '../store/actions/';

export const AuthContext = createContext();
export const AuthContextConsumer = AuthContext.Consumer;

const AuthContextProvider = (props) => {
    const [currentUser, setCurrentUser] = useImmer({});

    const history = useHistory();

    const dispatch = useDispatch();

    const filterComparison = (a, b) => {
        const changed = !_.isEqual(a, b);
        return changed;
    }
    const claimSelector = useSelector(state => state.applicationContext.currentUser?.permissions);
    const userSelector = useSelector(state => state.applicationContext.currentUser);

    useEffect(() => {
        setCurrentUser(userSelector);
    }, [userSelector])
   
    const hasPermission = (claim, values) => {
        let userClaims = claimSelector[claim];

        if (!Array.isArray(userClaims)) {
            userClaims = [userClaims];
        }

        if (!Array.isArray(values)) {
            values = [values];
        }

        return userClaims.some(c => values.includes(c));
    }

    const logOut = async () => {
        var authService = new AuthenticationService();
        await authService.logout();
        history.push('/login');
        // LOGOUT ON SERVER - delete cookie
        dispatch(applicationContextActionCreator.clearCurrentUser());
    }

    const getClaims = (claim) => {
        var userClaims = claimSelector[claim];

        if (!Array.isArray(userClaims)) {
            userClaims = [userClaims];
        }

        return userClaims;
    }

    const getClaim = (claim) => {
        var claim = claimSelector[claim];

        if (Array.isArray(claim)) {
            claim = claim[0];
        }

        return claim;
    }

    const showModal = (props, type) => {
        dispatch(modalActionCreator.showModal(props, type));
    }

    const hideModal = () => {
        dispatch(modalActionCreator.hideModal());
    }

    return (
        <AuthContext.Provider value={{
            currentUser,
            hasPermission,
            getClaims,
            getClaim,
            claims,
            claimValues,
            logOut,
            showModal,
            hideModal,
            userRoles
        }}>
            {props.children}
        </AuthContext.Provider >
    )
}

export default AuthContextProvider;